package com.terapia.terasenior.ui.patient

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.terapia.terasenior.domain.usecase.patient.CreatePatientUseCase
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed interface CreatePatientUiState {
    data object Idle : CreatePatientUiState
    data object Loading : CreatePatientUiState
    data object Success : CreatePatientUiState
    data class Error(val message: String) : CreatePatientUiState
}

class CreatePatientViewModel(
    private val createPatientUseCase: CreatePatientUseCase
) : ViewModel() {

    private val _uiState = MutableStateFlow<CreatePatientUiState>(CreatePatientUiState.Idle)
    val uiState: StateFlow<CreatePatientUiState> = _uiState.asStateFlow()

    fun createPatient(
        entityId: String,
        firstName: String,
        lastName: String,
        preferredName: String?,
        birthDate: String?,
        externalId: String?,
        nif: String?,
        admissionDate: String?,
        address: String?,
        city: String?,
        postalCode: String?,
        province: String?,
        phone: String?,
        contactName: String?,
        contactPhone: String?,
        notes: String?,
        status: com.terapia.terasenior.domain.model.patient.PatientStatus
    ) {
        viewModelScope.launch {
            _uiState.value = CreatePatientUiState.Loading
            createPatientUseCase(
                entityId, firstName, lastName, preferredName, birthDate, 
                externalId, nif, admissionDate, address, city, postalCode, province, phone, contactName, contactPhone, notes, status
            )
                .onSuccess {
                    _uiState.value = CreatePatientUiState.Success
                }
                .onFailure { error ->
                    _uiState.value = CreatePatientUiState.Error(
                        when {
                            error.message?.contains("invalid input syntax for type date") == true ->
                                "Una de las fechas no es válida. Usa el formato DD-MM-AAAA."
                            else -> "No se pudo crear el paciente. Comprueba los datos e inténtalo de nuevo."
                        }
                    )
                }
        }
    }

    fun resetState() {
        _uiState.value = CreatePatientUiState.Idle
    }
}
